import { sortByDate } from "../functions/sortByDate";
import useSourceFlowCollection from "./useSourceFlowCollection";
import data from "../.sourceflow/locations.json";

export const useLocations = ({ limit = null } = {}) => {
  const collection = useSourceFlowCollection(data);

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useLocations;
